import React, { useState } from 'react';
import PropTypes from 'prop-types';

const Tabs = ({ tabs, defaultTab, onChange }) => {
    const [activeTab, setActiveTab] = useState(defaultTab || tabs[0].id);

    const handleChange = (id) => {
        setActiveTab(id);

        if (onChange) {
            onChange(id);
        }
    };

    const activeTabData = tabs.find((tab) => tab.id === activeTab);

    const activeContent = activeTabData
        ? activeTabData.content
        : null;

    return (
        <div className='tabs-wrapper'>
            <div className='tabs'>
                {tabs.map((tab) => (
                    <button
                        key={tab.id}
                        className={`tab ${activeTab === tab.id ? 'active' : ''}`}
                        onClick={() => handleChange(tab.id)}
                    >
                        {tab.label}
                    </button>
                ))}
            </div>

            <div className='tab-content'>
                {activeContent}
            </div>
        </div>
    );
};

Tabs.propTypes = {
    tabs: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string.isRequired,
            label: PropTypes.string.isRequired,
            content: PropTypes.node,
        })
    ).isRequired,
    defaultTab: PropTypes.string,
    onChange: PropTypes.func,
};

export default Tabs;



// WEBPACK FOOTER //
// src/components/tabs.js